export enum ConvertCurrencies {
  MXN = 'wMXN',
  USD = 'wUSD',
  COP = 'wCOP',
}

export const accountTabLabels = ['afnGlobalAccount', 'afnLoanAccount'];

export const TAB_GLOBAL_ACCOUNT = 0;
export const TAB_LOAN_ACCOUNT = 1;
